// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__wluft","jpCurrentDate":"JP_Footer_jpCurrentDate__flIkx","jpFootage":"JP_Footer_jpFootage__ByRj8","higlight":"JP_Footer_higlight__tlutR"};